import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromRegion from './reducers/region.reducer';
import { RegionEffects } from './effects/region.effects';
import * as fromCountry from './reducers/country.reducer';
import { CountryEffects } from './effects/country.effects';
import * as fromRegionMember from './reducers/region-member.reducer';
import { RegionMemberEffects } from './effects/region-member.effects';
import * as fromMspRegion from './reducers/region-msp.reducer';
import { MspRegionEffects } from './effects/region-msp.effects';
import * as fromMspAuthority from './reducers/region-msp-authority.reducer';
import { MspAuthorityEffects } from './effects/region-msp-authority.effects';
import * as fromMspMemberAuthority from './reducers/region-msp-member-authority.reducer';
import { MspMemberAuthorityEffects } from './effects/region-msp-member-authority.effects';
import * as fromMspRegionPayment from './reducers/region-msp-payment.reducer';
import { MspRegionPaymentEffects } from './effects/region-msp-payment.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('region', fromRegion.reducer),
    EffectsModule.forFeature([RegionEffects, CountryEffects, RegionMemberEffects, MspRegionEffects, MspAuthorityEffects, MspMemberAuthorityEffects, MspRegionPaymentEffects]),
    StoreModule.forFeature('country', fromCountry.reducer),
    StoreModule.forFeature('regionMember', fromRegionMember.reducer),
    StoreModule.forFeature('mspRegion', fromMspRegion.reducer),
    StoreModule.forFeature('mspAuthority', fromMspAuthority.reducer),
    StoreModule.forFeature('mspMemberAuthority', fromMspMemberAuthority.reducer),
    StoreModule.forFeature('mspRegionFilter', fromMspRegion.MspRegionFilterreducer),
    StoreModule.forFeature('mspRegionPayment', fromMspRegionPayment.reducer),
    StoreModule.forFeature('mspDistributorRegionPayment', fromMspRegionPayment.reducerByDistributor),
    StoreModule.forFeature('mspPaymentDocumentList', fromMspRegionPayment.PaymentDocumentListReducer),
    StoreModule.forFeature('mspPaymentDocument', fromMspRegionPayment.PaymentDocumentReducer),
    StoreModule.forFeature('mspDeviceUsageList', fromMspRegionPayment.DeviceUsageListReducer),
    StoreModule.forFeature('mspDeviceUsage', fromMspRegionPayment.DeviceUsageReducer)
  ]
})
export class RegionModule { }
